import { createStore } from 'vuex';
import axios from 'axios';
import { getAuth, signInWithEmailAndPassword, signOut } from 'firebase/auth';
import { doc, getDoc } from 'firebase/firestore';
import { db } from './firebaseConfig'; // Importa l'istanza di Firestore

export default createStore({
  state: {
    userToken: null,
    userRole: null,
    user: null,
    orderDetails: null,
    selectedOrderServices: [],
    searchResults: [],
    filterByStatus: 'Aperto',
    filterByStudio: '',
    userEmail: localStorage.getItem('userEmail') || null, // Recupera l'email o imposta null

  },

  mutations: {
    SET_USER_UID(state, uid) {
      state.userUid = uid;
    },

    SET_USER_EMAIL(state, email) {
      state.userEmail = email;
      localStorage.setItem('userEmail', email); // Salva nel localStorage
    },
    

    SET_USER_TOKEN(state, token) {
      state.userToken = token;
    },

    SET_USER_ROLE(state, role) {
      state.userRole = role;
    },

    SET_USER(state, { user, token }) {
      state.user = user;
      state.userToken = token; // Assicurati di utilizzare il nome corretto della proprietà dello stato per il token
    },

    CLEAR_USER(state) {
      state.user = null;
      state.token = null;
    },

    SET_ORDER_DETAILS(state, orderDetails) {
      if (orderDetails && Array.isArray(orderDetails.products)) {
        state.orderDetails = orderDetails;
      } else {
        console.error('Dati dell\'ordine non validi:', orderDetails);
      }
    },

    SET_SELECTED_ORDER_SERVICES(state, services) {
      state.selectedOrderServices = services;
    },

    SET_SEARCH_RESULTS(state, users) {
      state.searchResults = users;
    },

    SET_FILTER_BY_STATUS(state, filterByStatus) {
      state.filterByStatus = filterByStatus;
    },

    SET_FILTER_BY_STUDIO(state, filterByStudio) {
      state.filterByStudio = filterByStudio;
    }
  },


  actions: {
    
    setUserEmail({ commit }, email) {
      commit('SET_USER_EMAIL', email); // Chiama la mutazione per salvare l'email
    },

    async login({ commit }, { email, password }) {
      const auth = getAuth();
      try {
        const userCredential = await signInWithEmailAndPassword(auth, email, password);
        const user = userCredential.user;
    
        console.log('User oggetto:', user); // Debug completo
        commit('SET_USER', user);
        commit('SET_USER_EMAIL', user.email); // Imposta direttamente l'email
        commit('SET_USER_TOKEN', user.accessToken);
    
        console.log('Email impostata:', user.email); // Conferma che l'email è stata salvata
      } catch (error) {
        console.error('Errore durante il login:', error);
      }
    },
    
async fetchUserDetails(_, userId) {
  try {
    const userRef = doc(db, 'users', userId);
    const userDoc = await getDoc(userRef);
    if (userDoc.exists()) {
      // Non aggiorniamo più l'email nello store!
      return userDoc.data(); // ritorna i dati se servono
    }
  } catch (error) {
    console.error('Errore durante il recupero dei dettagli dell\'utente:', error);
  }
},



    async logout({ commit }) {
      const auth = getAuth();
      try {
        await signOut(auth);
        commit('SET_USER', null);
        commit('SET_USER_TOKEN', null);
        commit('SET_USER_EMAIL', null); // Rimuovi l'email

        localStorage.removeItem('userEmail');

        
      } catch (error) {
        console.error('Errore durante il logout:', error);
      }
    },

    setUserUid({ commit }, uid) {
      commit('SET_USER_UID', uid);
    },

    setUserToken({ commit }, token) {
      commit('SET_USER_TOKEN', token);
    },

    setUserRole({ commit }, role) {
      commit('SET_USER_ROLE', role);
    },

    setUser({ commit }, { user, token }) {
      commit('SET_USER', user);
      commit('SET_USER_TOKEN', token);
    },

    clearUser({ commit }) {
      commit('CLEAR_USER');
    },

    updateOrderDetails({ commit }, orderDetails) {
      commit('SET_ORDER_DETAILS', orderDetails);
    },

    updateSelectedOrderServices({ commit }, services) {
      commit('SET_SELECTED_ORDER_SERVICES', services);
    },

    async searchUsers({ commit }, searchTerm) {
      try {
        const response = await axios.get('/api/users/search', { params: { query: searchTerm } });
        commit('SET_SEARCH_RESULTS', response.data);
      } catch (error) {
        console.error('Error during user search:', error);
      }
    },

    updateFilterByStatus({ commit }, filterByStatus) {
      commit('SET_FILTER_BY_STATUS', filterByStatus);
    },

    updateFilterByStudio({ commit }, filterByStudio) {
      commit('SET_FILTER_BY_STUDIO', filterByStudio);
    }
  },

  getters: {
    userToken: state => state.userToken,
    userRole: state => state.userRole,
    user: state => state.user,
    getOrderDetails: state => state.orderDetails,
    selectedOrderServices: state => state.selectedOrderServices,
    searchResults: state => state.searchResults,
    userEmail: (state) => state.userEmail,
    filterByStatus: state => state.filterByStatus,
    filterByStudio: state => state.filterByStudio
  }
});
